import React from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormSelectGroup } from "go-form/components/FormSelect";
import { apiOrganization } from "../../../../../../../../../../../../services/Api/Organization/apiOrganization";
import { VenueSettingsApi } from "../../../../../../../../../../../../services/Api/Organization/types";
import { SearchSelectApi } from "../../../../../../../../../../../../services/Api/types";

interface Props {
	form: UseFormReturn<VenueSettingsApi>;
}

const KioskSettingsMenuCard = ({ form }: Props) => {
	const { t } = useTranslation();
	const {
		formState: { errors },
		control,
		watch,
		setValue,
	} = form;

	const searchMenu = async (search: string, params: Record<string, any>, options?: Record<string, any>) => {
		return apiOrganization.getMenusSearchSelect(
			search,
			{
				...params,
				"type|e": "LIST",
			},
			{
				cancelToken: options?.token,
			}
		);
	};

	const searchAvailability = async (search: string, params: Record<string, any>, options?: Record<string, any>) => {
		return apiOrganization.getAvailabilitiesSearchSelect(search, params, {
			cancelToken: options?.token,
		});
	};

	const handleChangeAvailability = (value?: SearchSelectApi) => {
		if (!value) setValue("kiosk.availability.name", "");
		else setValue("kiosk.availability.name", value.label);
	};

	return (
		<fieldset className="form-group">
			<h6>{t("components.navigation.menu")}</h6>
			<FormSelectGroup
				errors={errors}
				control={control}
				name="kiosk.menu_id"
				loadOptions={searchMenu}
				getOptionValue={(option) => option.id}
				defaultValue={{
					id: watch("kiosk.menu")?.id,
					label: watch("kiosk.menu")?.name,
				}}
				label={t("components.navigation.menu")}
				data-testid="kiosk.menu_id"
			/>
			<div className="mt-3">
				<FormSelectGroup
					errors={errors}
					control={control}
					name="kiosk.availability_id"
					loadOptions={searchAvailability}
					getOptionValue={(option) => option.id}
					onChange={(_, obj) => handleChangeAvailability(obj)}
					defaultValue={{
						id: watch("kiosk.availability_id"),
						label: watch("kiosk.availability")?.name,
					}}
					label={t("modules.venue_settings.field.kiosk_working_schedule.title")}
					help={t("modules.venue_settings.field.kiosk_working_schedule.help_text")}
					data-testid="kiosk.KIOSK_WORKING_SCHEDULE"
				/>
			</div>
		</fieldset>
	);
};

export default KioskSettingsMenuCard;
